import DefaultHorizontalRule from '@tiptap/extension-horizontal-rule';
import { nodeInputRule } from '@tiptap/core';
import { PluginKey, Plugin } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { TiptapNodeType } from '../tiptapTypes';

const HR_SELECTION_PLUGIN_NAME = 'addHorizontalRuleSelection';

/**
 * Extends the default horizontal rule extension from Tiptap so that it can
 * handle "***" and "___" as well.
 */
export const HorizontalRule = DefaultHorizontalRule.extend({
    addInputRules() {
        return [
            nodeInputRule({
                find: /^(?:---|—-|___|\*\*\*)$/,
                type: this.type,
            }),
        ];
    },

    // Adds a 'selected' class to horizontal rules when they are selected.
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey(HR_SELECTION_PLUGIN_NAME),
                props: {
                    decorations(state) {
                        const selection = state.selection;
                        const decorations: Decoration[] = [];

                        state.doc.nodesBetween(selection.from, selection.to, (node, position) => {
                            if (node.type?.name === TiptapNodeType.horizontalRule) {
                                decorations.push(
                                    Decoration.node(position, position + node.nodeSize, { class: 'selected' }),
                                );
                            }
                        });

                        return DecorationSet.create(state.doc, decorations);
                    },
                },
            }),
        ];
    },
});
